export default "__VITE_ASSET__e8256ec1__"